import React, {useState, useEffect} from "react";
import { getWithExpiry } from '../../common';
import jwt_decode from "jwt-decode";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";

const HviPersonalSummary = (props) => {

    const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const [translation] = useTranslation("translations");
    const [questions, setQuestions] = useState([]);

    useEffect(() => {

        if ( props.questions ) {
            setQuestions( props.questions );
        } else {

            let qs = [
                'Meningsfullhet i vardagen',
                'Kontroll över vardagsstressen',
                'Tillräckligt med återhämtning',
                'Tillräckligt med sömn',
                'Balans mellan krav och resurser på jobbet',
                'Balans mellan krav och resurser hemma',
                'Ork på jobbet',
                'Ork hemma',
                'Nöjd med arbetsinsatsen',
                'Nöjd med fritiden',
                'Kan koppla bort jobbet när man är ledig',
                'Kan koppla bort privata frågor när man jobbar'
            ];
        
            if ( props.lang && props.lang === 'en' ) {
                qs = [
                    'Meaningfulness in everyday life',
                    'Control over everyday stress',
                    'Sufficient recovery',
                    'Sufficient sleep',
                    'Balance between demands and resources at work',
                    'Balance between demands and resources at home',
                    'Energy at work',
                    'Energy at home',
                    'Satisfied with work effort',
                    'Happy with free time',
                    'Can switch off work when free',
                    'Can put private matters aside when working'
                ];
            }

            setQuestions(qs);

        }

    }, [props.questions, props.lang]);

    const userHvi = props.userHvi;

    const getHviColor = (value, type) => {

        let color = 'sy-red';

        if ( type === 'total' ) {
            if ( value > 24 && value < 60 ) {
                color = 'sy-yellow';
            }
    
            if ( value > 59 ) {
                color = 'dark-green';
            }
        } else {
            if (  value === 3 || value === 4 ) {
                color = 'sy-yellow';
            }
    
            if (  value === 5 || value === 6 ) {
                color = 'sy-green';
            }
        }

        return color;

    }

    let recentHVI = userHvi;
    
    if ( userHvi.length > 1 ) {
        recentHVI = userHvi?.slice(Math.max(userHvi.length - 5, 0));
    }

    if ( ! recentHVI ) {
        recentHVI = [];
    }


    if ( props.isNew ) {
        const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);
        const newHvi = getWithExpiry( `sy_${jwtDecoded.id}_recent_hvi` );

        recentHVI.push(newHvi);
    }

    return(
        <div className="hvi-summary-wrap mt-5 mb-6">
            <table className="table table-hover table-striped">
                <thead className="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th></th>
                        { recentHVI?.map( (hvi, index) => {
                            const date = hvi.date.split('-');
                            const formatter = new Intl.DateTimeFormat('sv', { month: 'short' });
                            const month = formatter.format(new Date(hvi.date));

                            return (
                                <th scope="col" className="text-center" key={index}>{`${date[2]} `}<span className="text-capitalize">{month}</span></th>
                            );
                        }) }
                    </tr>
                </thead>
                <tbody>
                    { questions.map( (question, qindex ) => {
                        return(
                            <tr key={qindex}>
                                <th scope="row">{qindex+1}.</th>
                                <th>{question}</th>
                                { recentHVI?.map( (hvi, index) => {
                                    return (
                                        <td key={index} className="text-center"><span className={`bg-${getHviColor( hvi.data[qindex].value , 'single')} text-white py-2 px-4`}>{hvi.data[qindex].value}</span></td>
                                    );
                                }) }
                            </tr>
                        );
                        
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <td></td>
                        <td className="fw-bold pt-4 pb-3">{props?.textOne ? props?.textOne : translation('total_hvi') }</td>
                        { recentHVI?.map( (hvi, index) => {
                            return (
                                <td key={index} className="text-center pt-4 pb-3"><span className={`bg-${getHviColor( hvi.hvi_count , 'total')} text-white py-2 px-4`}>{hvi.hvi_count}</span></td>
                            );
                        }) }
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}

export default HviPersonalSummary;